import { Textarea } from "@chakra-ui/react";
import { isMobile } from "react-device-detect";
import TextareaAutosize from "react-textarea-autosize";
import { useAppContext } from "./AppContext";
import { useEffect, useRef } from "react";

interface VerseDisplayAreaProps {
  verse: string;
  setVerse: (value: string) => void;
  errorMsgs: string[];
  isQueryComplete: boolean;
}

// 250px = header (~84px) + input+gaps (~81px) + footer+spacing (~48px) + bottom padding (40px) - ~3px buffer
// Using dvh on mobile so it accounts for dynamic browser UI bars
export const maxTextAreaH = isMobile ? "calc(100dvh - 200px)" : "calc(95vh - 200px)";

export const VerseDisplayArea: React.FC<VerseDisplayAreaProps> = ({ verse, setVerse, errorMsgs }) => {
  const { textAreaFontSize, textAreaLineHeight } = useAppContext();
  const textAreaRef = useRef<HTMLTextAreaElement>(null);

  useEffect(() => {
    // Scroll to top when the verse changes
    if (textAreaRef.current) {
      textAreaRef.current.scrollTop = 0;
    }
  }, [verse]);

  return (
    <>
      <Textarea
        ref={textAreaRef}
        as={TextareaAutosize}
        minRows={5}
        maxH={maxTextAreaH}
        onChange={(e) => setVerse(e.target.value)}
        value={verse}
        resize="none" // Disable browser default resize
        borderColor={errorMsgs.includes(verse) ? "red.500" : undefined}
        fontSize={textAreaFontSize}
        lineHeight={textAreaLineHeight}
      />
    </>
  );
};
